<template>
    <el-dialog :visible.sync="addBsDialog" width="35%" top="3vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
        <el-card>
            <el-form ref="detailDialog" :model="bsForm" label-width="80px">
                <el-form-item label="商户账号" :required="true">
                    <el-input v-model="bsForm.account" placeholder="商户手机号"></el-input>
                </el-form-item>
                <el-form-item label="商户类型" align="left">
                <el-radio-group v-model="bsForm.type" @change="selectType">
                    <el-radio :label="global.bs_type[0].code" >{{ global.bs_type[0].message }}</el-radio>
                    <el-radio :label="global.bs_type[1].code" >{{ global.bs_type[1].message }}</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="主体名称">
                <el-input v-model="bsForm.subjectName" placeholder="商户名称"></el-input>
                </el-form-item>
                <el-form-item label="性别" align="left">
                <el-radio-group v-model="bsForm.gender" @change="chooseGender">
                    <el-radio label="0">男</el-radio>
                    <el-radio label="1">女</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="邮箱"><el-input v-model="bsForm.email" placeholder="邮箱" clearable></el-input></el-form-item>
                <el-form-item label="地区">
                    <el-select v-model="bsForm.province" clearable placeholder="省" @change="provinceChoose" style="width:160px">
                        <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
                    </el-select>
                    <el-select v-model="bsForm.city" clearable placeholder="市" @change="cityChoose" style="width:160px">
                        <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                    <el-select v-model="bsForm.area" clearable placeholder="区" style="width:160px" @change="areaChoose">
                        <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
                    </el-select>
                    </el-form-item>
                <el-form-item label="地址"><el-input v-model="bsForm.address" placeholder="地址" clearable></el-input></el-form-item>
                <el-form-item label="可见账单" align="left">
                <el-radio-group v-model="bsForm.rewardFlag">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="开通分润" align="left">
                <el-radio-group v-model="bsForm.rewardFlag">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                </el-radio-group>
                </el-form-item>
                <el-form-item label="分润比例" v-if="bsForm.rewardFlag == '1'">
                <el-input v-model="bsForm.rewardPercent" :disabled="false" placeholder="分润比例" clearable></el-input>
                </el-form-item>
                <el-form-item label="分润比例" v-else>
                <el-input v-model="bsForm.rewardPercent" :disabled="true" placeholder="分润比例" clearable></el-input>
                </el-form-item>
            </el-form>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button style="background-color:#A9F5F2;margin: 0" @click="addBsDialog = false">取消</el-button>
            <el-button style="background-color:#A9F5A9" @click="addBs()">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {addBsAccount} from '../../api/relation/businessstorerelation.js'
export default {
    data() {
        return {
            addBsDialog: false,
            loading: false,
            bsForm: {
                account: "",
                type: "0",
                typeStr: "普通商户",
                subjectName: "",
                gender: "0",
                genderStr: "",
                email: "",
                province: "",
                provinceStr: "",
                city: "",
                cityStr: "",
                area: "",
                areaStr: "",
                address: "",
                rewardFlag: '1',
                rewardPercent: "",
                billFlag: '1'
            },
            global: '',
            province: '',
            city: '',
            area: '',
            requestSucceed: false
        }
    },
    methods: {
        init(){
            this.addBsDialog = true;
        },

        /**
         * 商户类型选择
         */
        selectType(value){
            this.bsForm.typeStr = value === "0" ? "普通商户" : "特约商户";
        },

        /**
         * 性别选择
         */
        chooseGender(value){
            this.bsForm.genderStr = value === "0" ? "男" : "女"
        },

        /**
         * 添加商户
         */
        addBs(){
            if(this.bsForm.account === null || this.bsForm.account === undefined || this.bsForm.account === ""){
                this.$message({
                    message: "账号不能为空",
                    type: "error",
                    duration: 1500,
                });
                this.loading = false;
                return;
            }
            addBsAccount(this.bsForm).then(result=>{
                this.$emit('add-succeed','添加成功')
                this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500,
                });
                this.addBsDialog = false;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.bsForm.account = "";
            this.bsForm.type = "0";
            this.bsForm.typeStr = "普通商户";
            this.bsForm.subjectName = "";
            this.bsForm.gender = "0";
            this.bsForm.genderStr = "男";
            this.bsForm.email = "";
            this.bsForm.province = "";
            this.bsForm.provinceStr = "";
            this.bsForm.city = "";
            this.bsForm.cityStr = "";
            this.bsForm.area = "";
            this.bsForm.areaStr = "";
            this.bsForm.address = "";
            this.bsForm.rewardFlag = "1";
            this.bsForm.rewardPercent = "";
            this.bsForm.billFlag = "1";
            this.requestSucceed = false;
        },

        /**
        * 省下拉框选择触发事件
        */
        provinceChoose(value){
            this.bsForm.city = '';
            this.bsForm.area = '';
            for (let item of this.province) {
            if (value == item.code) {
                this.bsForm.provinceStr = item.value;
                this.city = item.childrenDictList
            }
            }
        },

        /**
        * 市下拉框选择触发事件
        */
        cityChoose(value){
            this.bsForm.area = '';
            for (let item of this.city) {
                if (value == item.code) {
                    this.bsForm.cityStr = item.value;
                    this.area = item.childrenDictList;
                }
            }
        },

        /**
        * 区下拉框选择触发事件
        */
        areaChoose(value){
            for (let item of this.city) {
                if (value == item.code) {
                    this.bsForm.areaStr = item.value;
                }
            }
        },

    },
    created() {
        this.global = JSON.parse(sessionStorage.getItem("global"));
        this.province = JSON.parse(sessionStorage.getItem("dict")).area;
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/relation/addBs.vue